import { ChatFixture, tokenize } from './types';

/**
 * Journey 5 — bilingual-flip.
 *
 * Same demand letter body from journey 4, but this time streamed in English
 * for the first paragraph and then flipped mid-render into Spanish.
 */

const englishOpening =
  'Dear [Recipient]: This firm represents [Client Name] in connection with [his/her] termination ' +
  'on [Date], which we believe constitutes wrongful termination in violation of public policy.\n\n';

const spanishBody = `Estimado/a [Destinatario]:

Este bufete representa a [Nombre del Cliente] en relación con su despido del [Fecha], el cual consideramos un despido injustificado en violación de la política pública de California, conforme a Tameny v. Atlantic Richfield Co., 27 Cal. 3d 167 (1980). Nuestro cliente ejerció una actividad protegida — específicamente, presentar un reclamo de compensación laboral el [Fecha del reclamo] — y fue despedido dentro de [N] días.

Exigimos: (1) reinstalación inmediata con antigüedad y beneficios completos; (2) pago retroactivo desde la fecha del despido; (3) daños compensatorios por angustia emocional en la cantidad de $[X]; y (4) honorarios de abogado conforme a Labor Code § 218.5.

Si no recibimos respuesta por escrito dentro de catorce (14) días, procederemos con una acción civil en la Corte Superior del Condado de Alameda.

Atentamente,

Fernando Hidalgo, Abogado
Colegio de Abogados No. [XXXXXX]`;

export const bilingualFlipFixture: ChatFixture = {
  id: 'bilingual-flip',
  userQuery: 'Translate that demand letter into Spanish for the client copy.',
  steps: ['english-preview', 'flip-trigger', 'spanish-stream', 'complete'],
  chunks: [
    { delta: '', delayMs: 180, event: 'thinking', data: { label: 'Preparing translation...' } },
    ...tokenize(englishOpening, 30),
    {
      delta: '',
      delayMs: 260,
      event: 'language_flip',
      data: { from: 'en', to: 'es', label: 'Switching to Spanish...' },
    },
    ...tokenize(spanishBody, 38),
  ],
};

export default bilingualFlipFixture;
